<template>
  <div class="more-annou">
    <div class="more-annou__content">
      <more-carousel :carouselList="newsBoxList" rounded="40" :title="title"/>
    </div>
  </div>
</template>
<script>
import {
  defineComponent, ref, shallowRef, watch,
} from 'vue';

import { v4 as uuid } from 'uuid';
import { useRoute } from 'vue-router';
import MoreCarousel from '@/components/Global/MoreCarousel.vue';
import MediaBox from '@/components/News/MediaBox.vue';
import { getViewArticlesAPI } from '@/api/articles';
import useRequest from '@/hooks/useRequest';
import previewImg from '@/assets/img/global/img_preview.jpg';

export default defineComponent({
  name: 'MoreMedia',
  components: {
    MoreCarousel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  setup() {
    const url = new URL(window.location.href);
    const nowID = url.searchParams.get('id');

    const route = useRoute();
    const newsBoxList = ref([]);

    const { response, request, isLoading } = useRequest(getViewArticlesAPI);

    request({
      page: 1,
      limit: 8,
      type: 'video',
      category: route.query.tab,
    });

    const getViewArticles = async (res) => {
      const {
        result: { data },
        status,
      } = res.value;

      if (status) {
        const baseUrl = process.env.VUE_APP_BASE_URL;
        const newData = data.filter((i) => i.uuid !== nowID);
        newsBoxList.value = newData.map((item) => {
          const coverImageSrc = item.cover_path ? `${baseUrl}${item.cover_path}` : previewImg;
          return {
            data: {
              title: item.title,
              desc: item.description,
              id: item.uuid,
            },
            id: uuid(),
            renderContent: shallowRef(MediaBox),
            imgPath: coverImageSrc,
          };
        });
      }
    };

    watch(response, () => {
      getViewArticles(response);
    });

    const articleList = ref();
    const itemWidth = ref();

    return {
      newsBoxList,
      articleList,
      itemWidth,
      isLoading,
    };
  },
});
</script>
